/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// eslint-disable-next-line import/prefer-default-export
export const payloadAddToCartCS = ({
    location, addToCartResp, trackPayload,
}) => {
    //  Build clickStream payload for clickstream.add-cart even
    let order;
    if (addToCartResp?.orderId[0]) {
        order = { orderId: addToCartResp.orderId[0] };
        order.orderItemId = addToCartResp.orderItemId[0];
    }
    let product;
    if (trackPayload?.products[0]) {
        const { baseCode, name, price } = trackPayload.products[0];
        product = {
            baseCode, name, price,
        };
    }
    const payload = {
        eventType: 'clickstream.add-cart',
        metaData: {
            order,
            product,
        },
    };
    if ((location?.state?.categoryPath || '')?.includes?.('searchterm')) {
        const searchTerm = location.state.categoryPath.split('/');
        payload.metaData.searchTerm = searchTerm[searchTerm.length - 1];
        payload.metaData.eventSubType = 'search';
    }
    return payload;
};
